import { useEffect, useState } from 'react'
import { useDebounce } from 'use-debounce'
import { ConnectionStatus } from '../../xmpp-client/XMPPClient'

const STATE_UPDATE_DELAY = 1000
const CLOSE_STATE_DELAY = 4000

export const useReconnectingStatus = (reconnectingStatus: ConnectionStatus) => {
  const [opened, setOpened] = useState(false)
  // used to trigger update for unit tests cause it cant wait for useEffect
  // so we wait for next update
  const [, setForceUpdate] = useState(0)
  const [delayedReconnectingStatus] = useDebounce(reconnectingStatus, STATE_UPDATE_DELAY)

  useEffect(() => {
    if (delayedReconnectingStatus !== 'CONNECTED') {
      setOpened(true)
    } else if (opened) {
      setTimeout(() => {
        setOpened(false)
      }, CLOSE_STATE_DELAY)
    }
    setForceUpdate(i => i + 1)
  }, [delayedReconnectingStatus, opened])

  return { opened, delayedReconnectingStatus }
}
